import 'css-chunksrc/client/pages/exportsPage/timesheetByTaskReport/sort/styles.scss';export default {
  "sort": "_sort_50xh2_1",
  "label": "_label_50xh2_9",
  "input": "_input_50xh2_15",
  "placeholder": "_placeholder_50xh2_31",
  "icon": "_icon_50xh2_39",
  "listRoot": "_listRoot_50xh2_47",
  "list": "_list_50xh2_47",
  "item": "_item_50xh2_63",
  "option": "_option_50xh2_76",
  "selected": "_selected_50xh2_83",
  "opened": "_opened_50xh2_96"
};